import axios from "axios";
import { apiEndpoint } from "../config";
import refreshInterceptor from "./refreshInterceptor/refreshInterceptor";

const TrueIdAPI = axios.create({
  baseURL: apiEndpoint.trueId,
  headers: {
    "content-type": "application/json",
  },
});

TrueIdAPI.interceptors.request.use(refreshInterceptor);

export default TrueIdAPI;
